export const siteData = {
  company: {
    name: 'Aurelian Heights',
    subtitle: 'Luxusimmobilienverwaltung',
    phone: '+49 2102 5659240',
    phoneHref: '+4921025659240',
    email: 'info@aurelianheights.de',
    address: {
      line1: 'Aurelian Heights Luxusimmobilienverwaltung GmbH',
      line2: 'Rosenstraße 23',
      line3: '40882 Ratingen'
    }
  },
  nav: [
    { label: 'Startseite', path: '/' },
    { label: 'Unternehmen', path: '/unternehmen' },
    { label: 'Leistungen', path: '/leistungen' },
    { label: 'Objekte', path: '/objekte' },
    { label: 'Kontakt', path: '/kontakt' }
  ],
  home: {
    eyebrow: 'Luxusimmobilienverwaltung',
    title: 'strategisches',
    titleAccent: 'Property Management',
    intro: 'Immobilien sind langfristige Werte. Sie begleiten Menschen und Unternehmen über viele Jahre und gewinnen mit der Zeit immer weiter an Bedeutung.',
    intro2: 'Aurelian Heights übernimmt dort, wo diese langfristige Perspektive Struktur, Klarheit und Verlässlichkeit braucht – mit einem Managementansatz, der nicht nur Immobilienbestände verwaltet, sondern Eigentümer und Mieter begleitet. Nachhaltige Wertstabilisierung und Weiterentwicklung der uns anvertrauten Liegenschaften sind unsere zentrale Aufgabenstellung.',
    heroImage: 'https://images.unsplash.com/photo-1648502298359-055a3f374705?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzc2Njc1ODI5fDA&ixlib=rb-4.1.0&q=85',
    focus: {
      title: 'Unser Fokus',
      text: 'Aurelian Heights betreut Luxusimmobilien und hochwertige Bestände, die professionell und vorausschauend gemanagt werden müssen. Der Schwerpunkt liegt auf Wohn- und Gewerbeimmobilienbeständen im Großraum Düsseldorf/Ruhrgebiet, bei denen unterschiedliche Interessen zusammenkommen und dauerhaft in Einklang gehalten werden sollen. Wir arbeiten für Family Offices, institutionelle Investoren und Vermögensverwalter, die langfristig denken und eine Verwaltung schätzen, die verlässlich und diskret agiert.'
    },
    pillars: [
      'Individuelles Objektmanagement',
      'Werte erhaltend agieren',
      'Zeitgemäße technische und energetische Ausrichtung'
    ],
    pillarsText: 'Luxusimmobilienverwaltung braucht heute mehr als reine Organisation. Sie erfordert Effizienz, Verlässlichkeit und ein proaktives Handeln, das erforderliche Maßnahmen früh erkennt und nachvollziehbar umsetzt. Aurelian Heights setzt dabei auf moderne, digitale Prozesse, klare Kommunikation und einen diskreten, transparenten Umgang mit allen Beteiligten.',
    stats: [
      { value: '25+', label: 'Jahre Erfahrung' },
      { value: '450', label: 'Verwaltete Einheiten' },
      { value: '98%', label: 'Kundenzufriedenheit' },
      { value: '24/7', label: 'Digitale Erreichbarkeit' }
    ]
  },
  services: {
    eyebrow: 'Leistungen',
    title: 'leistungsstark,',
    titleAccent: 'strategisch, digital',
    intro: 'Immobilien sind Werte, deren Potenzial sich langfristig entfaltet, wenn alle Aspekte professionell gesteuert werden. Leistungsstarkes Property Management verbindet kaufmännische, technische und organisatorische Ebenen, führt Prozesse klar zusammen und nutzt digitale Werkzeuge, um Entscheidungen fundiert und transparent umzusetzen.',
    intro2: 'Aurelian Heights übernimmt diese Verantwortung – mit einer Arbeitsweise, die Übersicht und Struktur schafft und Sicherheit gibt, dass Luxusimmobilien umfassend betreut und zukunftsorientiert entwickelt werden.',
    list: [
      {
        id: 'kaufmaennisch',
        number: '01',
        title: 'Kaufmännische Verwaltung',
        text: 'Die kaufmännische Verwaltung Ihrer Immobilien sorgt dafür, dass finanzielle Belange zuverlässig und transparent umgesetzt werden. Rechnungen, Abrechnungen und Budgetplanung werden präzise gesteuert, Risiken frühzeitig erkannt und wirtschaftliche Entscheidungen fundiert unterstützt – so behalten Eigentümer jederzeit den Überblick über ihre Immobilienwerte.',
        image: 'https://images.unsplash.com/photo-1765371514288-56aea621fbb1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxlbGVnYW50JTIwb2ZmaWNlJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc2Nzc0MTA1fDA&ixlib=rb-4.1.0&q=85'
      },
      {
        id: 'technisch',
        number: '02',
        title: 'Technische Verwaltung',
        text: 'Die technische Verwaltung stellt sicher, dass Immobilien in einem einwandfreien Zustand bleiben. Wartung, Instandhaltung und kontinuierliche Qualitätskontrollen werden strukturiert geplant und umgesetzt, sodass Objekte zuverlässig funktionieren, ein attraktives Umfeld für Mieter bleiben und ihr Wert langfristig gesichert ist.',
        image: 'https://images.unsplash.com/photo-1776482128008-2c9cf5bc0edc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwb2ZmaWNlJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc2Nzc0MTA1fDA&ixlib=rb-4.1.0&q=85'
      },
      {
        id: 'mieter',
        number: '03',
        title: 'Mieter- und Nutzerkommunikation',
        text: 'Die Mieter- und Nutzerkommunikation bei Aurelian Heights ist klar strukturiert und digital organisiert. Anfragen, Abstimmungen und Informationen werden effizient gesteuert und transparent dokumentiert, sodass alle Beteiligten jederzeit auf einem aktuellen Stand sind und Vorgänge nachvollziehbar bleiben.',
        image: 'https://images.unsplash.com/photo-1622015663319-e97e697503ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzc2Njc1ODI5fDA&ixlib=rb-4.1.0&q=85'
      },
      {
        id: 'strategie',
        number: '04',
        title: 'Strategie & Organisation',
        text: 'Strategie und Organisation bilden das Fundament eines leistungsfähigen Property Managements. Prozesse, Zuständigkeiten und Strukturen werden so ausgerichtet, dass Immobilienbestände effizient geführt und langfristige Ziele konsequent umgesetzt werden können.',
        image: 'https://images.unsplash.com/photo-1771270759486-1f7703945072?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwb2ZmaWNlJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc2Nzc0MTA1fDA&ixlib=rb-4.1.0&q=85'
      },
      {
        id: 'digital',
        number: '05',
        title: 'Digitale Mieterkommunikation',
        text: 'Die digitale Mieter- und Nutzerkommunikation erfolgt über eine zentrale App, die Informationen und Austausch zeitgemäß bündelt. Relevante Inhalte werden strukturiert bereitgestellt, Kommunikation wird nachvollziehbar geführt und Prozesse bleiben transparent dokumentiert. So entsteht ein effizienter Informationsfluss, der Nutzer und Verwaltung digital miteinander verbindet.',
        image: 'https://images.pexels.com/photos/30973393/pexels-photo-30973393.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
      }
    ]
  },
  about: {
    eyebrow: 'Aurelian Heights',
    title: 'Strategisches',
    titleAccent: 'Property Management',
    intro: 'Immobilien prägen Räume über viele Jahre hinweg. Damit sie ihre Qualität behalten und ihr Potenzial entfalten können, braucht es eine Verwaltung, die mit Verantwortung und Weitblick handelt.',
    intro2: 'Aurelian Heights steht für diese Haltung – mit einem Anspruch an Klarheit, Verlässlichkeit und einer Arbeitsweise, die Luxusimmobilien nicht nur organisiert, sondern langfristig begleitet.',
    values: [
      'Individuelles Objektmanagement',
      'Werte erhaltend agieren',
      'Marktgerecht und preisbewusst',
      'Zeitgemäße technische und energetische Ausrichtung',
      'Interessen moderieren',
      'Sachverständige Qualitätskontrollen',
      'Netzwerke aus Handwerkern, Notaren und Dienstleistern'
    ],
    region: {
      title: 'Großraum Düsseldorf',
      text: 'Aurelian Heights agiert im Wirtschaftsraum Düsseldorf – mit Präsenz unter anderem in Düsseldorf, Ratingen, Essen und Mönchengladbach. Die regionale Verankerung ermöglicht Überblick und belastbare Netzwerke – für eine Verwaltung, die Luxusimmobilien effizient steuert und Entwicklungen gezielt unterstützt.',
      image: 'https://images.pexels.com/photos/17446194/pexels-photo-17446194.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
    }
  },
  objects: {
    eyebrow: 'Objekte',
    title: 'Immobilien\u00ADbestände',
    titleAccent: 'mit Perspektive',
    intro: 'Immobilien sind Werte, die kontinuierlich gepflegt, gesteuert und entwickelt werden müssen. Aurelian Heights begleitet Luxusimmobilien unterschiedlicher Größenordnung – von Büro- und Gewerbeobjekten bis hin zu privaten Immobilienportfolios – mit einem Blick für Struktur, Übersicht und Werterhalt.',
    portfolio: [
      { title: 'Bürogebäude & Gewerbeimmobilien', text: 'Strategisch geführte Verwaltung von Bürogebäuden und Gewerbeobjekten mit Fokus auf Werterhalt, Energieeffizienz und professionelle Mieterbetreuung.' },
      { title: 'Luxuriöse Wohnportfolios', text: 'Ganzheitliches Management ausgewählter Wohnportfolios – von Einzelobjekten bis zu umfangreichen Beständen – mit einem Blick für Qualität und Kontinuität.' },
      { title: 'Family Office Bestände', text: 'Diskrete, maßgeschneiderte Betreuung privater Immobilienvermögen mit individueller Strategie und persönlichem Ansprechpartner.' },
      { title: 'Gemischt genutzte Quartiere', text: 'Koordinierte Verwaltung von Mixed-Use Objekten mit vielfältigen Nutzungsprofilen – strukturiert, transparent und vorausschauend.' }
    ],
    bigImage: 'https://images.unsplash.com/photo-1622015663319-e97e697503ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzc2Njc1ODI5fDA&ixlib=rb-4.1.0&q=85',
    teamImage: 'https://images.pexels.com/photos/5778603/pexels-photo-5778603.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    references: [
      { name: 'Büroquartier Düsseldorf', type: 'Gewerbe', area: '18.500 m²', city: 'Düsseldorf' },
      { name: 'Wohnpalais Ratingen', type: 'Wohnen', area: '9.200 m²', city: 'Ratingen' },
      { name: 'Ruhrkontor', type: 'Mixed-Use', area: '24.700 m²', city: 'Essen' },
      { name: 'Gartenhöfe Mönchengladbach', type: 'Wohnen', area: '12.400 m²', city: 'Mönchengladbach' }
    ]
  }
};
